import React from 'react';

/**
 * ChartLoader - Individual chart loading overlay
 * Shown when a chart is updating
 * 
 * Features:
 * - Grayed and blurred chart content
 * - Wave animation
 * - Non-intrusive overlay
 */
export const ChartLoader: React.FC = () => {
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center">
      {/* Wave Animation Container */}
      <div className="relative w-full h-full overflow-hidden">
        {/* Wave effect */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="wave-loader">
            <div className="wave-bar" style={{ animationDelay: '0s' }}></div>
            <div className="wave-bar" style={{ animationDelay: '0.1s' }}></div>
            <div className="wave-bar" style={{ animationDelay: '0.2s' }}></div>
            <div className="wave-bar" style={{ animationDelay: '0.3s' }}></div>
            <div className="wave-bar" style={{ animationDelay: '0.4s' }}></div>
          </div>
        </div>
      </div>

      {/* CSS for wave animation - injected as style tag */}
      <style>{`
        .wave-loader {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          height: 40px;
        }

        .wave-bar {
          width: 4px;
          height: 100%;
          background-color: #c7613d; /* accent-primary */
          border-radius: 2px;
          animation: wave 1.2s ease-in-out infinite;
        }

        @keyframes wave {
          0%, 100% {
            transform: scaleY(0.3);
            opacity: 0.5;
          }
          50% {
            transform: scaleY(1);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};
